import Cookies from 'js-cookie';

export const setAuthCookie = (token, expirationDate) => {
	const expiration = new Date(expirationDate);
	Cookies.set('authToken', token, { expires: expiration, sameSite: 'strict' });
};

export const getAuthCookie = () => {
	const token = Cookies.get('authToken');
	if (!token) return 'expired';
	return token;
};

export const removeAuthCookie = () => {
	Cookies.remove('authToken');
};
